export default "__VITE_ASSET__47f810aa__"